import React, { type FC, useEffect, useState } from 'react'

import {
  Loading,
  MESSAGE_BOX_VARIANT_DANGER,
  MessageBox,
  PageHeader,
} from 'mailup-web-components'

import PageContainer from 'Components/PageContainer'

import type { AuthPageState } from 'Pages/AuthPage/model'
import { initApp } from 'Pages/AuthPage/services'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { useSetRecoilState } from 'recoil'
import { getAuthParams } from '../../helpers/authHelper'
import { localeSelector } from '../../state/localeState'

const AuthPage: FC = () => {
  const navigate = useNavigate()
  const intl = useIntl()

  const { seckey, list, redirectTo, loginType } = getAuthParams(
    window.location.search,
  )

  const setLocale = useSetRecoilState(localeSelector)

  const [pageState, setPageState] = useState<AuthPageState>({
    loading: false,
    status: 'initial',
  })

  useEffect(() => {
    setPageState((prev) => ({ ...prev, loading: true }))

    if (
      seckey !== null &&
      list !== null &&
      loginType !== null &&
      redirectTo !== null
    ) {
      initApp({
        seckey,
        idList: list,
        loginType,
      })
        .then((lang) => {
          setLocale(lang)

          if (redirectTo.startsWith('/')) {
            navigate(redirectTo, { replace: true })
          } else {
            navigate('/recipients/list', { replace: true })
          }
        })
        .catch((error) => {
          console.error('### error', error)
          setPageState((prev) => ({ ...prev, loading: false, status: 'error' }))
        })
    } else {
      //  wrong params
      console.error('### error', 'wrong params')
      setPageState((prev) => ({ ...prev, loading: false, status: 'error' }))
    }
  }, [])

  return (
    <>
      <PageHeader breadcrumbsItems={[]} menuItems={undefined} />
      <Loading open={pageState.loading} />
      <PageContainer>
        {pageState.status === 'error' && (
          <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
            {intl.formatMessage({ id: 'Load.Alerts.ErrorGeneric' })}
          </MessageBox>
        )}
      </PageContainer>
    </>
  )
}

export default AuthPage
